(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fresh-for-two-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fft-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-fft-slide]');
    gallery.querySelectorAll('[data-fft-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.fftSlide === thumb.dataset.fftThumb));
        gallery.querySelectorAll('[data-fft-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });

  document.querySelectorAll('.fft-product').forEach((section) => {
    const select = section.querySelector('[data-fft-variant-select]');
    const price = section.querySelector('[data-fft-price]');
    const comparePrice = section.querySelector('[data-fft-compare-price]');
    const discountNote = section.querySelector('[data-fft-discount-note]');
    const stickyPrice = section.querySelector('[data-fft-sticky-price]');
    const submit = section.querySelector('[data-fft-submit]');
    const buttonText = section.querySelector('[data-fft-button-text]');

    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (price) price.textContent = option.dataset.price;
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
        }
        if (discountNote) {
          const discount = Number(option.dataset.discount || 0);
          discountNote.textContent = discount > 0 ? `SAVE ${discount}%` : '';
          discountNote.hidden = discount <= 0;
        }
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (submit) submit.disabled = !available;
        if (buttonText) buttonText.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
      });
    }

    const sticky = section.querySelector('[data-fft-sticky]');
    const form = section.querySelector('[data-fft-product-form]');
    if (!sticky) return;
    const updateSticky = () => {
      if (window.innerWidth > 800 || window.scrollY < 520) {
        sticky.classList.remove('is-visible');
        return;
      }
      if (!form) {
        sticky.classList.add('is-visible');
        return;
      }
      const rect = form.getBoundingClientRect();
      const formVisible = rect.top < window.innerHeight - 90 && rect.bottom > 90;
      sticky.classList.toggle('is-visible', !formVisible);
    };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
